(() => {
  const getSlides = (card) => Array.from(card.querySelectorAll('[data-gallery-slide]'));

  const setActiveDot = (card, activeIndex) => {
    card.querySelectorAll('[data-gallery-dot]').forEach((dot, index) => {
      const active = index === activeIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-gallery-prev], [data-gallery-next], [data-gallery-dot]');
    if (!control) return;

    const card = control.closest('product-item');
    const track = card?.querySelector('[data-gallery-track]');
    const slides = card ? getSlides(card) : [];
    if (!track || slides.length < 2) return;

    event.preventDefault();
    event.stopPropagation();

    const currentIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    const isDot = control.matches('[data-gallery-dot]');
    const dotIndex = isDot ? Array.from(card.querySelectorAll('[data-gallery-dot]')).indexOf(control) : -1;
    const direction = control.hasAttribute('data-gallery-next') ? 1 : -1;
    const nextIndex = isDot ? dotIndex : (currentIndex + direction + slides.length) % slides.length;

    if (nextIndex >= 0) {
      track.scrollTo({ left: slides[nextIndex].offsetLeft, behavior: 'smooth' });
      setActiveDot(card, nextIndex);
    }
  });

  document.addEventListener('scroll', (event) => {
    const track = event.target.closest?.('[data-gallery-track]');
    if (!track || !track.clientWidth) return;

    const card = track.closest('product-item');
    setActiveDot(card, Math.round(track.scrollLeft / track.clientWidth));
  }, true);

  document.addEventListener('change', (event) => {
    const swatch = event.target.closest?.('[data-gallery-variant-id]');
    if (!swatch) return;

    const card = swatch.closest('product-item');
    const variantId = swatch.getAttribute('data-gallery-variant-id');
    const featuredMediaId = swatch.getAttribute('data-gallery-variant-media');

    card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      const url = new URL(link.href, window.location.href);
      url.searchParams.set('variant', variantId);
      link.href = url.toString();
    });

    if (!featuredMediaId) return;

    const slides = getSlides(card);
    const slide = slides.find((item) => item.getAttribute('data-media-id') === featuredMediaId);
    const track = card.querySelector('[data-gallery-track]');
    if (!slide || !track) return;

    const index = slides.indexOf(slide);
    track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    setActiveDot(card, index);
  });
})();
